import { LinkIcon } from "@heroicons/react/outline";
import Button from "components/Button";

export const EmptyUrlsState = ({
  hasActiveFilters = false,
  description = "No URLs to display.",
}: {
  hasActiveFilters?: boolean;
  description?: string;
}) => (
  <div className="flex flex-col items-center justify-center">
    <LinkIcon className="w-16 h-16 mb-4 text-gray-300" />
    <h3 className="text-lg font-medium text-gray-900 mb-1">{hasActiveFilters ? "No URLs found" : "No URLs"}</h3>
    <p className="text-sm max-w-md text-center text-gray-500">
      {hasActiveFilters
        ? "No URLs match the current filters. Try adjusting your search or status filter."
        : description}
    </p>
  </div>
);

export const UrlsTableErrorState = ({ error, onRetry }: { error: string; onRetry?: () => void }) => (
  <div className="border border-gray-200 rounded-lg bg-white p-12 flex flex-col items-center justify-center gap-4">
    <span className="text-red-600">{error}</span>
    {onRetry && <Button text="TRY AGAIN" className="button button-secondary" size="MD" onClick={onRetry} />}
  </div>
);
